interface Technology {
  name: string
  level: string
  icon: string
}

interface ExperienceSlide {
  title: string
  technologies: Technology[]
  direction: "left" | "right"
  color: string
}

  export const slideVariants = {
    enter: (direction: string) => ({
      x: direction === "left" ? -1000 : 1000,
      opacity: 0,
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
    },
    exit: (direction: string) => ({
      zIndex: 0,
      x: direction === "left" ? 1000 : -1000,
      opacity: 0,
    }),
  }

  export const techVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.5,
        ease: "easeOut",
      },
    }),
  }

export const experienceData: ExperienceSlide[] = [
  {
    title: "Frontend Development",
    direction: "left",
    color: "#3b82f6",
    technologies: [
      { name: "HTML", level: "Experienced", icon: "🌐" },
      { name: "CSS", level: "Experienced", icon: "🎨" },
      { name: "JavaScript", level: "Experienced", icon: "⚡" },
      { name: "TypeScript", level: "Experienced", icon: "📘" },
      { name: "React", level: "Experienced", icon: "⚛️" },
      { name: "Next.js", level: "Experienced", icon: "▲" },
      { name: "Angular", level: "Experienced", icon: "🅰️" },
      { name: "Vue", level: "Experienced", icon: "💚" },
      { name: "Redux", level: "Experienced", icon: "🔄" },
      { name: "Tailwindcss", level: "Experienced", icon: "🦦" },
      { name: "Bootstrap", level: "Experienced", icon: "🅱️" },
      { name: "Shadcn-ui", level: "Experienced", icon: "🎯" },
    ],
  },
  {
    title: "Backend Development",
    direction: "right",
    color: "#10b981",
    technologies: [
      { name: "Node.js", level: "Experienced", icon: "🟢" },
      { name: "Express", level: "Experienced", icon: "🚀" },
      { name: "Nestjs", level: "Experienced", icon: "🦊" },
      { name: "PHP", level: "Experienced", icon: "🐘" },
      { name: "Laravel", level: "Experienced", icon: "🔴" },
      { name: "MySQL", level: "Experienced", icon: "🐬" },
      { name: "SQLServer", level: "Experienced", icon: "🗄️" },
      { name: "MongoDB", level: "Experienced", icon: "🍃" },
      { name: "Docker", level: "Experienced", icon: "🐳" },
      { name: "Sequelize", level: "Experienced", icon: "🔗" },
      { name: "Prisma", level: "Experienced", icon: "⚡" },
      { name: "Drizzle", level: "Experienced", icon: "⚡" },
    ],
  },
  {
    title: "Technologies & Tools",
    direction: "left",
    color: "#f59e0b",
    technologies: [
      { name: "Git-Github", level: "Experienced", icon: "🐙" },
      { name: "CI/CD", level: "Experienced", icon: "🤖" },
      { name: "RestFullAPI", level: "Experienced", icon: "🔌" },
      { name: "Clean Code", level: "Experienced", icon: "🧹" },
      { name: "Solid", level: "Experienced", icon: "🔧" },
      { name: "Scrum", level: "Experienced", icon: "🏃" },
      { name: "Notion", level: "Experienced", icon: "📝" },
      { name: "Jira", level: "Experienced", icon: "📋" },
      { name: "Linux", level: "Experienced", icon: "🐧" },
      { name: "Windows", level: "Experienced", icon: "🪟" },
      { name: "VSCode", level: "Experienced", icon: "💻" },
      { name: "AI", level: "Experienced", icon: "🤖" },
    ],
  },
  {
    title: "Cloud & Payment",
    direction: "right",
    color: "#8b5cf6",
    technologies: [
      { name: "Vercel", level: "Experienced", icon: "▲" },
      { name: "AWS", level: "Experienced", icon: "☁️" },
      { name: "GCP", level: "Experienced", icon: "🌤️" },
      { name: "D.Ocean", level: "Experienced", icon: "🌊" },
      { name: "Firebase", level: "Experienced", icon: "🔥" },
      { name: "Supabase", level: "Experienced", icon: "🚀" },
      { name: "Railway", level: "Experienced", icon: "🚂" },
      { name: "NeonDB", level: "Experienced", icon: "🗄️" },
      { name: "Heroku", level: "Experienced", icon: "🔥" },
      { name: "Paypal", level: "Experienced", icon: "💰" },
      { name: "Stripe", level: "Experienced", icon: "💳" },
      { name: "MercadoPago", level: "Experienced", icon: "💳" },
    ],
  },
]
